import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import TransferOutTrackingReportActions from '../../Stores/TransferOutTrackingReport/Actions';

const { Panel } = Collapse;

class TransferOutTrackingReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initTransferOutTracking } = this.props;

    if (curSiteFlowId > 0) {
      initTransferOutTracking();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initTransferOutTracking } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initTransferOutTracking();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'transfer_out_tracking_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

TransferOutTrackingReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initTransferOutTracking: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

TransferOutTrackingReportScreen.defaultProps = {
  intl: {},
  match: {},

  initTransferOutTracking: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initTransferOutTracking: () =>
    dispatch(TransferOutTrackingReportActions.transferOutTrackingReportInitTransferOutTracking())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(TransferOutTrackingReportScreen));
